import { useEffect } from "react";
import { useCustomSnackbars } from "components/snackbars/useCustomSnackbars";

export const ErrorFallback = () => {
  const { enqueueSupportSnackbar } = useCustomSnackbars();

  useEffect(() => {
    enqueueSupportSnackbar(
      "Something has gone wrong, please contact support.",
      "error",
    );
  }, [enqueueSupportSnackbar]);

  return <></>;
};
